import styled from 'styled-components';
import { useEffect, useState } from 'react';
import InterestSerivce from '../../../../service/Interest';
import { CaseInfo } from '../../data';
import { RowTable } from '../../../../func/components/Table';
import { NumberwithComma, ReportFormatNumber } from '../../../../func/Function';
import { useReportContext } from '../../../../context/DetailContext';
import { NplCalculation } from '../../../../utils/nplAnalysis';
import { INplInfo } from '../../../../service/detail/Detail';
import AddInterestItemModal from '../../../components/modal/AddInterestItem';
import { s } from './NPL.styles';

interface INPLSummaryProps {
  caseInfo: CaseInfo;
  summary: ReturnType<NplCalculation['getSummary']>;
  info: INplInfo;
}

const NPLSummary = (props: INPLSummaryProps) => {
  const [isLikeItem, setIsLikeItem] = useState(false);
  const [showLikeModal, setShowLikeModal] = useState(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const checkIsLikeItem = async (iidx: number) => {
    try {
      const res = await InterestSerivce.check(iidx);
      setIsLikeItem(res.data.is_like);
    } catch (error) {
      console.error('checkIsLikeItem 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    if (props.caseInfo?.iidx) {
      checkIsLikeItem(props.caseInfo?.iidx);
    }
  }, [isLikeItem]);

  const handleCopyAddress = () => {
    navigator.clipboard
      .writeText(props.caseInfo?.iaddr ? props.caseInfo?.iaddr : '')
      .then(() => {
        alert('주소가 복사되었습니다!');
      })
      .catch((err) => {
        console.error('주소 복사에 실패했습니다:', err);
        alert('주소 복사에 실패했습니다.');
      });
  };

  const handleTopAction = (action: string) => {
    if (action === 'share') {
      const currentUrl = window.location.href;
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
          alert('URL이 복사되었습니다!');
        })
        .catch(() => {
          alert('URL 복사에 실패했습니다.');
        });
    }
  };

  const disLike = async (iidx: number) => {
    try {
      const res = await InterestSerivce.dislike(iidx);
      alert('관심물건에서 삭제되었습니다.');
      setIsLikeItem(false);
    } catch (error) {
      console.error('dislike 함수에서 에러 발생:', error);
    }
  };

  const handleDisLikeItem = (iidx: number) => {
    if (window.confirm('관심물건에서 삭제하시겠습니까?')) {
      disLike(iidx);
    }
  };

  const { summary, info } = props;
  return (
    <div>
      <s.Div style={{ marginBottom: '0px' }}>
        <s.Title>NPL 분석요약</s.Title>
        <s.Table>
          <s.TableRow>
            <s.RowCategory>부동산 표시</s.RowCategory>
            <s.RowContent style={{ backgroundColor: '#F2F8FF' }}>
              {info.address}
            </s.RowContent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>사건번호</s.RowCategory>
            <s.RowContent>{info.caseno}</s.RowContent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>법원</s.RowCategory>
            <s.RowContent>{info.court}</s.RowContent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>채권자</s.RowCategory>
            <s.RowContent>{info.creditee}</s.RowContent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>채무자 (소유자)</s.RowCategory>
            <s.RowContent>{info.rightholder}</s.RowContent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>경매개시일</s.RowCategory>
            <s.RowContent>
              {info.start_date.split(' ')[0].replaceAll('-', '.')}
            </s.RowContent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>배당종기일</s.RowCategory>
            <s.RowContent>
              {info.div_date.split(' ')[0].replaceAll('-', '.')}
            </s.RowContent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>법원감정가격</s.RowCategory>
            <RowNum>{ReportFormatNumber(summary.row1)}</RowNum>
            <RowPercent>100.00%</RowPercent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>AI 시세추정</s.RowCategory>
            <RowNum>{ReportFormatNumber(summary.row2_1)}</RowNum>
            <RowPercent>{ReportFormatNumber(summary.row2_2, true)}</RowPercent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>청구금액</s.RowCategory>
            <RowNum>{ReportFormatNumber(summary.row3_1)}</RowNum>
            <RowPercent>{ReportFormatNumber(summary.row3_2, true)}</RowPercent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>예상낙찰가격</s.RowCategory>
            <RowNum>{ReportFormatNumber(summary.row4_1)}</RowNum>
            <RowPercent>{ReportFormatNumber(summary.row4_2, true)}</RowPercent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>
              (통계)예상
              <br />
              낙찰가율
            </s.RowCategory>
            <RowNum>{ReportFormatNumber(summary.row5_1)}</RowNum>
            <RowPercent>{ReportFormatNumber(summary.row5_2, true)}</RowPercent>
          </s.TableRow>
          <s.TableRow>
            <s.RowCategory>
              (AI)예상
              <br />
              낙찰가율
            </s.RowCategory>
            <RowNum>{ReportFormatNumber(summary.row6_1)}</RowNum>
            <RowPercent>{ReportFormatNumber(summary.row6_2, true)}</RowPercent>
          </s.TableRow>
        </s.Table>
      </s.Div>
      <div
        style={{
          width: '100%',
          borderTop: '1px solid rgba(112, 115, 124, 0.16)',
          backgroundColor: '#fff',
          marginBottom: '8px',
        }}
      >
        <s.InterestButtonBox>
          <s.InterestButton onClick={() => handleTopAction('share')}>
            <img src="/assets/images/icon/upload-gray.svg" alt="" />
            <span>공유</span>
          </s.InterestButton>
          <s.Divider> </s.Divider>
          <s.InterestButton
            onClick={(e) => {
              e.stopPropagation();

              if (!isLikeItem) {
                setShowLikeModal(true);
              } else {
                handleDisLikeItem(props.caseInfo?.iidx);
              }
            }}
          >
            <img
              src={`/assets/images/icon/${isLikeItem ? 'filled-star' : 'lined-star'}.svg`}
              alt=""
            />
            <span>관심</span>
          </s.InterestButton>
        </s.InterestButtonBox>
        {showLikeModal && (
          <AddInterestItemModal
            setShowLikeModal={setShowLikeModal}
            selectedIdx={props.caseInfo?.iidx}
            mode={mode}
            selectedItem={selectedItem}
            setActiveItem={setActiveItem}
            checkIsLikeItem={checkIsLikeItem}
          />
        )}
      </div>
    </div>
  );
};

export default NPLSummary;

const RowNum = styled.div`
  width: 50%;
  background-color: #f2f8ff;
  text-align: right;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: end;
  border-right: 1px solid #e1e2e4;
`;

const RowPercent = styled.div`
  width: 50%;
  background-color: #f2f8ff;
  text-align: right;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: end;
`;
